import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useTenantSafe } from '../context/TenantContext';
import { canStaffSection } from '../utils/staffAccess';

export default function StaffSectionRoute({ section, children }) {
  const { user, activeTenant } = useAuth();
  const tenantCtx = useTenantSafe();
  const tenantId = tenantCtx?.viewTenant?._id || activeTenant?._id;
  return canStaffSection(user, tenantId, section)
    ? children : <p role="alert">You do not have staff access to this section.</p>;
}
